import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import './login.css';
import { login as loginThunk, selectAuthLoading } from "../auth/authSlice";
import { ToastContainer, toast } from "react-toastify";

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(selectAuthLoading);

    const redirectByRole = (role) => {
        const normalized = String(role || "").toLowerCase();
        if (normalized === "admin") return navigate("/adminDashboard");
        return navigate("/myresearch");
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const resultAction = await dispatch(
                loginThunk({
                    email: username,
                    // username: username,
                    // username,
                    password,
                })
            );

            if (loginThunk.fulfilled.match(resultAction)) {
                const role = resultAction.payload?.user?.role || resultAction.payload?.role;
                localStorage.setItem("username", username);
                toast.success("Login successful");
                // let the toast show briefly before route change
                setTimeout(() => redirectByRole(role), 1500);
            } else {
                const message =
                    resultAction.payload?.message ||
                    resultAction.error?.message ||
                    "Login failed. Please check your credentials.";
                toast.error(message);
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error('An error occurred during login. Please try again.');
        }
    };

    const handleGoogleLogin = () => {
        // Add Google OAuth logic here
        console.log('Google login clicked');

        // Navigate to dashboard after successful Google login
        navigate('/dashboard');
    };

    return (
        <div className="login-container">
            <ToastContainer
                position="top-right"
                autoClose={2500}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Left Side - Logo */}
            <div className="logo-section">
                <div className="logo-content">
                    <div className="dna-icon">
                        <img src="/Slide4.png" alt="HealthLabs AI Logo" />
                    </div>
                </div>
            </div>

            {/* Right Side - Login Form */}
            <div className="form-section">
                <div className="form-content">
                    {/* <h2 className="form-title">Cortex@HealthLabsAI</h2> */}
                    <h2 className="form-title">Welcome To HealthLabs AI</h2>

                    <form onSubmit={handleLogin}>
                        <div className="input-group">
                            <div className="input-wrapper">
                                <span className="input-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                            stroke="#4a5568"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <circle cx="12" cy="7" r="4" stroke="#4a5568" strokeWidth="2" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder="Username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="form-input"
                                // required
                                />
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="input-wrapper">
                                <span className="input-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <rect
                                            x="3"
                                            y="11"
                                            width="18"
                                            height="11"
                                            rx="2"
                                            stroke="#4a5568"
                                            strokeWidth="2"
                                        />
                                        <path
                                            d="M7 11V7a5 5 0 0 1 10 0v4"
                                            stroke="#4a5568"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </span>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="form-input"
                                    required
                                />
                                <button
                                    type="button"
                                    className="toggle-password"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                                                stroke="#4a5568"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <line x1="1" y1="1" x2="23" y2="23" stroke="#4a5568" strokeWidth="2" />
                                        </svg>
                                    ) : (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                                stroke="#4a5568"
                                                strokeWidth="2"
                                            />
                                            <circle cx="12" cy="12" r="3" stroke="#4a5568" strokeWidth="2" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                            <div className="forgot-password" style={{ textAlign: 'right', marginTop: "10px" ,cursor: 'pointer' ,marginLeft: '70%'}}
                            //  onClick={()=>navigate('/forgotpassword')}
                             >Forgot Password?</div>
                        </div>


                        <button type="submit" className="login-button" disabled={loading}>
                            {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="10" fill="white" fillOpacity="0.3" />
                                <path
                                    d="M8 12l4 4l4-4"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    transform="rotate(-90 12 12)"
                                />
                            </svg> */}
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>

                    {/* <div className="divider">
                        <span>OR</span>
                    </div>

                    <button className="google-button" onClick={handleGoogleLogin}>
                        <svg width="24" height="24" viewBox="0 0 24 24">
                            <path
                                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                fill="#4285F4"
                            />
                            <path
                                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                fill="#34A853"
                            />
                            <path
                                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                fill="#FBBC05"
                            />
                            <path
                                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                fill="#EA4335"
                            />
                        </svg>
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default Login;

